import { NumberInput, Slider } from 'carbon-components-react';
import { formsInterface } from '../../lib/type';
import './Forms.scss';
import {
  MutableRefObject,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { calculations } from '../../utils/calculation/calculation';
import { layoutContext } from '../Context/RoiCalculator';

const Forms = (formsProps: { contents: formsInterface; jsondata: any }) => {
  const { contents, jsondata } = formsProps;
  const inputRef = useRef() as MutableRefObject<HTMLInputElement>;
  const { setOutput } = useContext(layoutContext);

  const [sliderValueOne, setSliderValueOne] = useState(70);
  const [sliderValueTwo, setSliderValueTwo] = useState(30);
  const [sliderValueThree, setSliderValueThree] = useState(35);

  const handleSliderChangeOne = (value: number) => {
    if (value > 100) {
      setSliderValueOne(100);
    } else {
      setSliderValueOne(value);
    }
  };

  const handleSliderChangeTwo = (value: number) => {
    if (value > 100) {
      setSliderValueTwo(100);
    } else {
      setSliderValueTwo(value);
    }
  };

  const [operational, setOperational] = useState({
    numOfHrEmployees: 0,
    hrsSpentOnLowComplexityPerDay: 0,
    ticketsPerDay: 0,
    numOfDaysTakesToHire: 0,
  });

  const handleInputs = (e: MutableRefObject<HTMLInputElement>) => {
    const current = e.current as HTMLInputElement;
    const name = current.name;
    const value = current.value;
    if (/^\d*\.?\d+$/.test(value) || value === '') {
      setOperational({ ...operational, [name]: value });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await calculations(
        operational.hrsSpentOnLowComplexityPerDay,
        operational.numOfHrEmployees,
        operational.ticketsPerDay,
        sliderValueOne / 100,
        sliderValueTwo / 100,
        jsondata,
      );

      setOutput(response);
    };

    fetchData();
  }, [operational, sliderValueThree, sliderValueOne, sliderValueTwo]);

  return (
    <div className="bx--grid roi-calculator__forms">
      <div className="roi-calculator__forms-title bx--row">
        <div className="roi-calculator__forms-title-number">1</div>
        <p className="roi-calculator__forms-title-text">{contents.title1}</p>
      </div>
      <div className="roi-calculator__forms-inputs bx--row">
        <div className="roi-calculator__forms-inputs-number bx--col-lg-5 bx--col-md-7 bx--col-sm-4">
          <NumberInput
            size="md"
            id="carbon-number"
            name="numOfHrEmployees"
            min={0}
            value={operational.numOfHrEmployees}
            ref={inputRef}
            onChange={() => handleInputs(inputRef)}
            invalidText="Number is not valid"
            className="roi-calculator__forms-inputs-number-box"
          />
          <p className="roi-calculator__forms-inputs-number-subtext">
            {contents.input1}
          </p>
        </div>
        <div className="roi-calculator__forms-inputs-number bx--col-lg-5 bx--col-md-7 bx--col-sm-4">
          <NumberInput
            size="md"
            id="carbon-number"
            name="hrsSpentOnLowComplexityPerDay"
            min={0}
            value={operational.hrsSpentOnLowComplexityPerDay}
            ref={inputRef}
            onChange={() => handleInputs(inputRef)}
            invalidText="Number is not valid"
            className="roi-calculator__forms-inputs-number-box"
          />
          <p className="roi-calculator__forms-inputs-number-subtext">
            {contents.input2}
          </p>
        </div>
        <div className="roi-calculator__forms-inputs-number bx--col-lg-5 bx--col-md-7 bx--col-sm-4">
          <NumberInput
            size="md"
            id="carbon-number"
            name="ticketsPerDay"
            min={0}
            value={operational.ticketsPerDay}
            ref={inputRef}
            onChange={() => handleInputs(inputRef)}
            invalidText="Number is not valid"
            className="roi-calculator__forms-inputs-number-box"
          />
          <p className="roi-calculator__forms-inputs-number-subtext">
            {contents.input3}
          </p>
        </div>
      </div>
      <div className="roi-calculator__forms-title bx--row">
        <div className="roi-calculator__forms-title-number">2</div>
        <p className="roi-calculator__forms-title-text">{contents.title2}</p>
      </div>
      <div className="roi-calculator__forms-inputs bx--row">
        <div className="roi-calculator__forms-inputs-number bx--col-lg-5 bx--col-md-7 bx--col-sm-4">
          <Slider
            labelText={contents.upBar1}
            value={sliderValueOne}
            min={0}
            max={100}
            step={1}
            stepMultiplier={10}
            onChange={(e: any) => handleSliderChangeOne(e.value)}
            className="roi-calculator__forms-inputs-number-box"
            onBlur={() => {
              null;
            }} //empty function added to avoid slider bug
          />
        </div>
        <div className="roi-calculator__forms-inputs-number bx--col-lg-5 bx--col-md-7 bx--col-sm-4">
          <Slider
            labelText={contents.upBar2}
            value={sliderValueTwo}
            min={0}
            max={100}
            step={1}
            stepMultiplier={10}
            onChange={(e: any) => handleSliderChangeTwo(e.value)}
            className="roi-calculator__forms-inputs-number-box"
            onBlur={() => {
              null;
            }} //empty function added to avoid slider bug
          />
        </div>
      </div>
    </div>
  );
};

export default Forms;
